import { Box, styled } from '@mui/material';

type IconStatusProps = {
  status?: 'success' | 'error' | 'default';
  shape?: 'circle' | 'square';
};

export const IconStatus = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status' && prop !== 'shape',
})<IconStatusProps>(({ theme, status = 'default', shape = 'circle' }) => {
  const isDark = theme.palette.mode === 'dark';

  const backgroundByStatus: Record<NonNullable<IconStatusProps['status']>, string> = {
    success: isDark ? theme.palette.green[900] : theme.palette.green[50],
    error: isDark ? theme.palette.red[700] : theme.palette.red[50],
    default: isDark ? theme.palette.black[850] : theme.palette.gray[50],
  };

  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 32,
    borderRadius: shape === 'square' ? theme.spacing(1) : '50%',
    backgroundColor: backgroundByStatus[status],
  };
});
